module.exports = __webpack_public_path__ + "img/2.17a9d667.jpg";